import React, { useState, useEffect } from 'react';
import { Button } from 'src/@/components/ui/button';
import { useDispatch, useSelector } from 'react-redux';
import useAuth from 'src/hooks/useAuth';
import Iconify from 'src/components/Iconify';
import DrawerNegocioNotas from './components/DrawerNegocioNotas';
import DrawerNegocioTimeline from './components/DrawerNegocioTimeline';
import { useSnackbar } from 'notistack';
import DrawerContatos from './components/DrawerContatos';
import DrawerCustomTabs from './DrawerCustomTabs';
import {
    getChatInfoByChatId,
    getMensagensWhatsappDb,
    limparChats,
    setChatInfo,
    setLimparChatInfo,
} from 'src/redux/slices/chat';
import { fDateTime, fToNow } from 'src/utils/formatTime';

// ----------------------------------------------------------------------
// CONSTANTES E CONFIGURAÇÕES
// ----------------------------------------------------------------------

const QUALIFICACAO_LABELS = {
    1: 'Sem interesse',
    2: 'Frio',
    3: 'Morno',
    4: 'Esquentando',
    5: 'Quente',
};

// Componente de rating customizado usando Tailwind CSS
const CustomRating = ({ value, onChange, onChangeActive, icon, emptyIcon, max = 5 }) => {
    return (
        <div className="flex gap-1">
            {[...Array(max)].map((_, index) => {
                const ratingValue = index + 1;
                return (
                    <button
                        key={index}
                        type="button"
                        className="p-0.5 border-0 bg-transparent cursor-pointer rounded-full hover:bg-orange-50 dark:hover:bg-orange-500/10 transition-all duration-150 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-orange-200 dark:focus:ring-orange-500/30"
                        onClick={() => onChange(ratingValue)}
                        onMouseEnter={() => onChangeActive && onChangeActive(null, ratingValue)}
                        onMouseLeave={() => onChangeActive && onChangeActive(null, -1)}
                    >
                        <div className="w-4 h-4 flex items-center justify-center">{ratingValue <= value ? icon : emptyIcon}</div>
                    </button>
                );
            })}
        </div>
    );
};

//actions
import v2_actionDetalhesLead from 'src/actions/v2/crm/v2_actionDetalhesLead';
import v2_actionEditarLead from 'src/actions/v2/crm/v2_actionEditarLead';
import { Card } from 'src/@/components/ui/card';
import { ResizablePanelGroup, ResizablePanel, ResizableHandle } from 'src/@/components/ui/resizable';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from 'src/@/components/ui/accordion';
import { Tabs as TabsUI, TabsList as TabsListUI, TabsTrigger as TabsTriggerUI, TabsContent as TabsContentUI } from 'src/@/components/ui/tabs';
import DrawerTransferirLead from './components/DrawerTransferirLead';
import ComponentCloseLead from './components/ComponentCloseLead';
import {
    Dialog,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from 'src/@/components/ui/dialog';
import { Input } from 'src/@/components/ui/input';
import { Label } from 'src/@/components/ui/label';

// Componente DialogContent customizado sem botão de fechar
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { cn } from 'src/@/lib/utils';

const DialogContent = React.forwardRef(({ className, children, ...props }, ref) => (
    <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay
            className={cn(
                'fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0'
            )}
        />
        <DialogPrimitive.Content
            ref={ref}
            className={cn(
                'fixed left-[50%] top-[50%] z-50 w-full translate-x-[-50%] translate-y-[-50%] border border-gray-200 dark:border-[#383838] bg-white dark:bg-[#1A1D21] shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]',
                className
            )}
            {...props}
        >
            {children}
        </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
));
DialogContent.displayName = 'DialogContent';

import { ChatWindow } from 'src/sections/@chats/chat';
import DrawerTabNegocio from './components/DrawerTabNegocio';
import NegociosHeader from './NegociosHeader';
import DrawerConvertLead from './components/DrawerConvertLead';
import { Badge } from 'src/@/components/ui/badge';
import DrawerDeleteLead from './components/DrawerDeleteLead';
import v2_actionGetLeadScore from 'src/actions/v2/crm/v2_actionGetLeadScore';
import ScoreGauge from './components/ScoreGauge';
import DrawerRealEstate from './components/DrawerRealEstate';

export default function ModalNegocio({ configCrm, open, onClose, lead, chat, source, callbackRefreshLeads }) {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const [leadData, setLeadData] = useState(null);
    const { chatInfo } = useSelector((state) => state.chat);
    const { config } = useSelector((state) => state.global);
    const { user, cliente } = useAuth();
    const [isEditNomeLead, setIsEditNomeLead] = useState(false);
    const [nomeLead, setNomeLead] = useState(null);
    const [sidebarLeft, setSidebarLeft] = useState(false);
    const [openCloseLead, setOpenCloseLead] = useState(false);
    const [openDeleteLead, setOpenDeleteLead] = useState(false);
    const [hover, setHover] = useState(-1);
    const [leadScore, setLeadScore] = useState({ score: 0, credits: 0, debits: 0 });

    function handleCloseChat(open) {
        console.log('ModalNegocio handleCloseChat chamado com:', open);
        // Se open é false, significa que o dialog está sendo fechado
        if (open === false) {
            dispatch(setLimparChatInfo());
            onClose();
        }
    }

    function setar(lead) {
        console.log('ModalNegocio setar chamado com:', lead);
        setLeadData(lead);
        setNomeLead(lead?.nome);
    }

    async function handleLoadChat(value, clienteWhatsapp) {
        if (!value) return;
        dispatch(getMensagensWhatsappDb(clienteWhatsapp?.sessao, value.numero, 1, 10));
        dispatch(getChatInfoByChatId(value._id, value.funil_id, user.id, true));
    }

    useEffect(() => {
        console.log('ModalNegocio useEffect executado com:', { lead, open });
        setar(lead);
        if (lead?._id && open) {
            buscarLeadScore(lead._id);
        }
        if (source === 'chat') {
            handleLoadChat(chat, lead?.clienteWhatsapp);
            return;
        }
        handleLoadChat(lead?.whatsapp, lead?.clienteWhatsapp);
        return () => {
            dispatch(setLimparChatInfo());
        };
    }, [lead, open]);

    // Cleanup adicional quando o modal for fechado
    useEffect(() => {
        if (!open) {
            dispatch(setLimparChatInfo());
        }
    }, [open, dispatch]);

    async function buscarLeadScore(id) {
        try {
            const result = await v2_actionGetLeadScore(id);
            if (result.data?.data) {
                setLeadScore(result.data.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function buscarDetalhesLead(id) {
        try {
            const result = await v2_actionDetalhesLead(id);
            const data = result.data.data;
            if (data) {
                setLeadData(data);
            }
            console.log('data', data);
        } catch (error) {
            console.log(error);
        }
    }

    async function editarLead(action, value) {
        if (action === 'editar_conversao') {
            let data = {
                action: action,
                scope: {
                    convertido: value ? Number(value) : null,
                },
            };
            await v2_actionEditarLead(lead._id, data, user.id);
            enqueueSnackbar('Negócio alterado com sucesso', {
                variant: 'success',
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            });
        }

        if (action === 'editar_contato') {
            let data = {
                action: action,
                scope: {
                    contato_id: value,
                },
            };
            await v2_actionEditarLead(lead._id, data, user.id);
            enqueueSnackbar('Contato alterado com sucesso', {
                variant: 'success',
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            });
        }

        if (action === 'editar_nome_lead') {
            let data = {
                action: action,
                scope: {
                    nome: value,
                },
            };
            await v2_actionEditarLead(lead._id, data, user.id);
            enqueueSnackbar('Lead alterado com sucesso', {
                variant: 'success',
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            });
        }

        if (action === 'retomar_lead') {
            let data = { action: action, scope: value };
            await v2_actionEditarLead(lead._id, data, user.id);
            enqueueSnackbar('Lead alterado com sucesso', {
                variant: 'success',
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            });
        }

        if (action === 'editar_qualificacao') {
            let data = {
                action: action,
                scope: {
                    qualificacao: value,
                },
            };
            await v2_actionEditarLead(lead._id, data, user.id);
            enqueueSnackbar('Qualificação alterada com sucesso', {
                variant: 'success',
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            });
        }

        if (action === 'editar_chat_whatsapp') {
            let data = {
                action: action,
                scope: {
                    whatsapp_chat_id: value,
                },
            };
            await v2_actionEditarLead(lead._id, data, user.id);
            enqueueSnackbar('Chat alterado com sucesso', {
                variant: 'success',
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            });
        }

        setTimeout(() => {
            buscarDetalhesLead(lead._id);
            callbackRefreshLeads();
        }, 1000);
    }

    async function handleAlterarQualificacao(value) {
        if (lead?.closed) {
            enqueueSnackbar('Não é possível alterar, reabra o lead antes de continuar', {
                variant: 'error',
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            });
            return;
        }
        await editarLead('editar_qualificacao', value);
    }

    const labels = {
        1: 'Venda',
        2: 'Perda',
    };

    return (
        <Dialog open={open} onOpenChange={handleCloseChat}>
            <DialogContent
                className="flex flex-col min-w-[97%] h-full bg-gradient-to-br from-neutral-100 bg-neutral-100 dark:from-[#1A1D21] dark:via-[#1A1D21] dark:to-[#1A1D21] p-2"
                onInteractOutside={(e) => {
                    // Previne fechamento ao clicar fora do modal
                    e.preventDefault();
                }}
            >
                {!lead ? (
                    <div className="flex items-center justify-center h-full animate-in fade-in zoom-in-95 duration-300">
                        <div className="text-center space-y-3">
                            <Iconify icon="eos-icons:loading" width={32} className="text-[#0052cc] mx-auto animate-spin" />
                            <p className="text-sm font-medium text-gray-500 dark:text-[#ABABAD] animate-pulse">Carregando dados do lead...</p>
                        </div>
                    </div>
                ) : (
                    <div className="flex flex-col h-full w-full">
                        <div className="flex-shrink-0 animate-in fade-in slide-in-from-top-4 duration-500">
                            <div className="flex items-center justify-between mt-2">
                                {/* Lado esquerdo - Botão voltar e nome do lead */}
                                <div className="flex items-center gap-3">
                                    <Button variant="secondary" size="icon" onClick={onClose} className="w-8 h-8">
                                        <Iconify icon="material-symbols:arrow-back-ios-new" className="font-[15px]" />
                                    </Button>
                                    <div className="flex items-center gap-2">
                                        {isEditNomeLead ? (
                                            <div className="flex items-center gap-2">
                                                <Input
                                                    className="w-[350px]"
                                                    value={nomeLead || ''}
                                                    onChange={(e) => setNomeLead(e.target.value)}
                                                />
                                                <Button variant="ghost" size="icon" onClick={() => editarLead('editar_nome_lead', nomeLead)} className="w-8 h-8">
                                                    <Iconify width={18} icon="el:ok-sign" />
                                                </Button>
                                            </div>
                                        ) : (
                                            <div className="flex items-center gap-2">
                                                <span className="text-sm font-medium text-gray-900 dark:text-gray-100">
                                                    {leadData?.nome}
                                                </span>
                                                <Button variant="ghost" size="icon" onClick={() => setIsEditNomeLead(true)} className="w-8 h-8">
                                                    <Iconify width={18} icon="fa7-regular:edit" />
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Lado direito - Informações e ações */}
                                <div className="flex items-center gap-6">
                                    {/* Datas e qualificação */}
                                    <div className="flex items-center gap-4">
                                        {/* <div className="flex flex-col items-center">
                                            <span className="text-[10px] text-gray-500 dark:text-[#ABABAD] font-medium mb-0.5">Score</span>
                                            <ScoreGauge score={leadScore?.score} />
                                        </div> */}

                                        <NegociosHeader
                                            lead={leadData}
                                            user={user}
                                            cliente={cliente}
                                            onVincularChat={async (value) => {
                                                try {
                                                    console.log('Vincular chat ao lead:', value);
                                                    await editarLead('editar_chat_whatsapp', value._id);
                                                    // Carregar as mensagens do chat
                                                    dispatch(getMensagensWhatsappDb(leadData?.clienteWhatsapp?.sessao, value.numero, 1, 10));
                                                    dispatch(setChatInfo(value));
                                                    dispatch(getChatInfoByChatId(value._id, value.funil_id, user.id, true));
                                                } catch (error) {
                                                    console.error('Erro ao vincular chat:', error);
                                                    throw error;
                                                }
                                            }}
                                            onOpenChatWhatsapp={async (value) => {
                                                try {
                                                    console.log('Vincular chat ao lead:', value);
                                                    // Carregar as mensagens do chat
                                                    dispatch(getMensagensWhatsappDb(leadData?.clienteWhatsapp?.sessao, value.numero, 1, 10));
                                                    dispatch(setChatInfo(value));
                                                    dispatch(getChatInfoByChatId(value._id, value.funil_id, user.id, true));
                                                } catch (error) {
                                                    console.error('Erro ao vincular chat:', error);
                                                    throw error;
                                                }
                                            }}
                                            onDesvincularChat={async () => {
                                                try {
                                                    // Desvincular o chat do lead
                                                    await editarLead('editar_chat_whatsapp', null);
                                                    // Limpar o chat atual
                                                    dispatch(setChatInfo(null));
                                                    dispatch(limparChats());
                                                    // Atualizar os dados do lead
                                                    await buscarDetalhesLead(lead._id);
                                                    callbackRefreshLeads();
                                                } catch (error) {
                                                    console.error('Erro ao desvincular chat:', error);
                                                    throw error;
                                                }
                                            }}
                                        />

                                        {/* Qualificação */}
                                        <div className="flex flex-col items-center">
                                            <CustomRating
                                                onChange={handleAlterarQualificacao}
                                                icon={
                                                    <Iconify
                                                        width={18}
                                                        height={18}
                                                        icon="fluent:fire-24-filled"
                                                        className="text-orange-500"
                                                    />
                                                }
                                                emptyIcon={
                                                    <Iconify
                                                        width={18}
                                                        height={18}
                                                        icon="fluent:fire-24-regular"
                                                        className="text-gray-300 dark:text-[#565856]"
                                                    />
                                                }
                                                max={5}
                                                value={leadData?.qualificacao || 0}
                                                onChangeActive={(event, newHover) => setHover(newHover)}
                                            />
                                            <p className="text-xs text-gray-600 dark:text-[#ABABAD] font-medium mt-1">
                                                {QUALIFICACAO_LABELS[hover !== -1 ? hover : leadData?.qualificacao || 0]}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Status de conversão */}
                                    {leadData?.convertido ? (
                                        <Badge
                                            variant="secondary"
                                            className={`h-7 px-3 font-medium rounded-md transition-all duration-300 ease-in-out hover:scale-105 ${leadData?.convertido === 1
                                                ? 'bg-green-100 dark:bg-green-500/10 text-green-800 dark:text-green-400 border border-green-300 dark:border-green-500/30'
                                                : 'bg-red-100 dark:bg-red-500/10 text-red-800 dark:text-red-400 border border-red-300 dark:border-red-500/30'
                                                } cursor-pointer animate-in zoom-in duration-300`}
                                        >
                                            <div
                                                onClick={async () => {
                                                    if (leadData?.closed) {
                                                        enqueueSnackbar('Não é possível alterar com o lead finalizado', {
                                                            variant: 'error',
                                                            autoHideDuration: 3000,
                                                            anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
                                                        });
                                                        return;
                                                    }
                                                    await editarLead('editar_conversao', {
                                                        convertido: null,
                                                        motivo_perda: null,
                                                        data_conversao: null,
                                                    });
                                                    callbackRefreshLeads();
                                                }}
                                                className={`${leadData?.convertido === 1 ? 'hover:bg-green-600 bg-green-500' : 'hover:bg-red-600 bg-red-500'
                                                    } rounded-md h-4 w-4 flex justify-center items-center ml-2 transition-colors duration-200`}
                                            >
                                                <Iconify icon="iconamoon:close-bold" className="text-white text-[10px] font-bold" />
                                            </div>
                                            {labels[leadData?.convertido]}
                                        </Badge>
                                    ) : (
                                        <DrawerConvertLead
                                            lead={lead}
                                            user={user}
                                            configCrm={configCrm}
                                            onCallback={() => {
                                                buscarDetalhesLead(lead._id);
                                                callbackRefreshLeads();
                                            }}
                                        />
                                    )}

                                    {/* Ações do lead */}
                                    <div className="flex items-center gap-2">
                                        {leadData?.closed ? (
                                            <Badge
                                                variant="secondary"
                                                className="h-7 px-3 font-medium rounded-md bg-violet-100 dark:bg-violet-500/10 text-violet-800 dark:text-violet-400 border border-violet-300 dark:border-violet-500/30 cursor-pointer transition-all duration-300 ease-in-out hover:scale-105 animate-in zoom-in duration-300"
                                            >
                                                <div
                                                    onClick={async () => {
                                                        try {
                                                            await editarLead('retomar_lead', { closed: false, data_finalizacao: null });
                                                            callbackRefreshLeads();
                                                        } catch (err) {
                                                            console.log(err);
                                                        }
                                                    }}
                                                    className="hover:bg-violet-300 bg-violet-400 rounded-md h-3 w-4 flex justify-center items-center ml-2"
                                                >
                                                    <Iconify icon="icon-park-outline:back" className="text-white text-[8px]" />
                                                </div>
                                                Lead finalizado
                                            </Badge>
                                        ) : (
                                            <ComponentCloseLead
                                                lead={leadData}
                                                onOpen={setOpenCloseLead}
                                                open={openCloseLead}
                                                user={user}
                                                onCallback={() => {
                                                    buscarDetalhesLead(lead._id);
                                                    callbackRefreshLeads();
                                                    onClose();
                                                }}
                                                onOpenChange={() => setOpenCloseLead(!openCloseLead)}
                                            />
                                        )}
                                        <DrawerTransferirLead
                                            lead={leadData}
                                            user={user}
                                            onCallback={() => {
                                                buscarDetalhesLead(lead._id);
                                                callbackRefreshLeads();
                                                onClose();
                                            }}
                                        />
                                        <DrawerDeleteLead
                                            lead={leadData}
                                            user={user}
                                            open={openDeleteLead}
                                            onOpenChange={() => setOpenDeleteLead(!openDeleteLead)}
                                            onCallback={() => {
                                                callbackRefreshLeads();
                                                onClose();
                                            }}
                                        />
                                        <Button variant="secondary" size="icon" onClick={onClose} className="w-8 h-8">
                                            <Iconify icon="material-symbols:close" className="font-[15px] text-red-800" />
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Pipeline Stages - full width */}
                        <div className="animate-in fade-in slide-in-from-bottom-2 duration-500 delay-100 fill-mode-both">
                            <DrawerTabNegocio
                                key={`negocio-${lead?._id}`}
                            lead={leadData}
                            configCrm={configCrm}
                            user={user}
                            cliente={cliente}
                            callbackRefreshLeads={callbackRefreshLeads}
                            callBackRefreshLead={() => buscarDetalhesLead(lead._id)}
                            onOpenChatWhatsapp={(value) => {
                                try {
                                    dispatch(getMensagensWhatsappDb(leadData?.clienteWhatsapp?.sessao, value.numero, 1, 10));
                                    dispatch(setChatInfo(value));
                                    dispatch(getChatInfoByChatId(value._id, value.funil_id, user.id, true));
                                } catch (error) {
                                    console.log(error);
                                }
                            }}
                        />
                        </div>

                        <ResizablePanelGroup direction="horizontal" className="h-full flex-1 gap-2 animate-in fade-in slide-in-from-bottom-4 duration-700 delay-200 fill-mode-both">
                            {/* Painel Esquerdo - Accordions */}
                            <ResizablePanel defaultSize={35} minSize={25} className="min-h-0 overflow-hidden transition-all duration-300">
                                <Card className="h-full flex flex-col min-h-0 overflow-hidden border-gray-200 dark:border-[#383838] transition-all duration-300">
                                    <div className="p-0 flex-1 flex flex-col min-h-0 overflow-hidden">
                                        <div className="h-full overflow-auto p-4 bg-white dark:bg-[#1A1D21]">
                                            <LeadSectionsRenderer
                                                layoutConfig={configCrm?.layoutConfig}
                                                hasCustomTabs={configCrm?.customTabs?.length > 0}
                                                hasRealEstate={!!cliente?.config?.modules?.realestate?.status}
                                                sections={{
                                                    negociacao: (
                                                        <>
                                                            <div className="flex flex-col gap-3 mb-4">
                                                                <div className="flex items-center gap-3">
                                                                    <label className="text-[11px] font-semibold uppercase tracking-wider text-gray-500 dark:text-[#8b8d90] shrink-0 min-w-[100px]">Criado em</label>
                                                                    <p className="text-[13px] font-semibold text-neutral-700 dark:text-[#D1D2D3]">{lead?.data_criacao ? fDateTime(lead.data_criacao) : '-'}</p>
                                                                </div>
                                                                <div className="flex items-center gap-3">
                                                                    <label className="text-[11px] font-semibold uppercase tracking-wider text-gray-500 dark:text-[#8b8d90] shrink-0 min-w-[100px]">Atualização</label>
                                                                    <p className="text-[13px] font-semibold text-neutral-700 dark:text-[#D1D2D3]">{lead?.data_modificacao ? fToNow(lead.data_modificacao) : '-'}</p>
                                                                </div>
                                                            </div>
                                                            <DrawerTabNegocio
                                                                key={`info-${lead?._id}`}
                                                                lead={leadData}
                                                                configCrm={configCrm}
                                                                user={user}
                                                                cliente={cliente}
                                                                callbackRefreshLeads={callbackRefreshLeads}
                                                                callBackRefreshLead={() => buscarDetalhesLead(lead._id)}
                                                                renderMode="info-only"
                                                            />
                                                        </>
                                                    ),
                                                    contatos: (
                                                        <DrawerContatos
                                                            key={`contatos-${lead?._id}`}
                                                            user={user}
                                                            cliente={cliente}
                                                            lead={leadData}
                                                            onEditarContatoId={(value) => editarLead('editar_contato', value)}
                                                            callbackCreateContact={() => buscarDetalhesLead(lead._id)}
                                                        />
                                                    ),
                                                    atividades: (
                                                        <DrawerNegocioTimeline key={`atividades-${lead?._id}`} data={leadData?.historico} />
                                                    ),
                                                    comentarios: (
                                                        <DrawerNegocioNotas
                                                            key={`comentarios-${lead?._id}`}
                                                            refreshLead={() => buscarDetalhesLead(lead._id)}
                                                            user={user}
                                                            dataLead={leadData}
                                                        />
                                                    ),
                                                    campos_personalizados: configCrm?.customTabs?.length > 0 ? (
                                                        <DrawerCustomTabs
                                                            key={`custom-tabs-${lead?._id}`}
                                                            lead={leadData}
                                                            customTabs={configCrm.customTabs}
                                                            onRefresh={() => buscarDetalhesLead(lead._id)}
                                                        />
                                                    ) : null,
                                                    realestate: cliente?.config?.modules?.realestate?.status ? (
                                                        <DrawerRealEstate
                                                            key={`realestate-${lead?._id}`}
                                                            lead={leadData}
                                                        />
                                                    ) : null,
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Card>
                            </ResizablePanel>

                            <ResizableHandle withHandle className="!bg-transparent !border-l-1 !border-dashed !border-gray-300 dark:!border-[#383838]" />

                            {/* Painel Direito - Conversa */}
                            <ResizablePanel defaultSize={65} minSize={30} className="min-h-0 overflow-hidden flex flex-col transition-all duration-300">
                                <Card className="h-full flex flex-col min-h-0 overflow-hidden border-gray-200 dark:border-[#383838] transition-all duration-300">
                                    <div className="p-0 flex-1 flex flex-col min-h-0 overflow-hidden">

                                        <div className="flex flex-col flex-1 min-h-0 overflow-hidden h-full animate-in fade-in slide-in-from-right-4 duration-500 delay-300 fill-mode-both" onClick={(e) => e.stopPropagation()}>
                                            {chatInfo ? (
                                                <div className="flex-1 flex flex-col min-h-0 overflow-hidden h-full">
                                                    <ChatWindow
                                                        source="funil.chat"
                                                        sidebarLeft={sidebarLeft}
                                                        changeOpenSidebarLeft={() => {
                                                            setSidebarLeft(!sidebarLeft);
                                                        }}
                                                        config={config}
                                                        chatInfo={chatInfo}
                                                    />
                                                </div>
                                            ) : (
                                                <div className="flex flex-col justify-center items-center h-full bg-neutral-50 dark:bg-[#222529] rounded gap-4 animate-in fade-in zoom-in-95 duration-500 delay-300 fill-mode-both">
                                                    <div className="p-4 rounded-full bg-violet-100 dark:bg-violet-500/10">
                                                        <Iconify
                                                            icon="fluent:chat-empty-24-regular"
                                                            width={48}
                                                            height={48}
                                                            className="text-violet-500 dark:text-violet-400"
                                                        />
                                                    </div>
                                                    <p className="text-sm font-medium text-gray-500 dark:text-[#ABABAD]">
                                                        Nenhuma conversa iniciada ainda com este lead.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Card>
                            </ResizablePanel>
                        </ResizablePanelGroup>
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
}

// ======================================================================
// LeadSectionsRenderer — renders sections as Accordion or Tabs based on config
// ======================================================================

const DEFAULT_ORDEM = [
    { key: "negociacao", label: "Negociação", posicao: 0 },
    { key: "contatos", label: "Contatos", posicao: 1 },
    { key: "atividades", label: "Atividades", posicao: 2 },
    { key: "comentarios", label: "Comentários", posicao: 3 },
    { key: "campos_personalizados", label: "Campos Personalizados", posicao: 4 },
    { key: "realestate", label: "Imóvel", posicao: 5 }
];

function LeadSectionsRenderer({ layoutConfig, hasCustomTabs, hasRealEstate, sections }) {
    const modo = layoutConfig?.modo_visualizacao || 'accordion';
    const ordemBase = layoutConfig?.ordem_secoes?.length > 0
        ? [...layoutConfig.ordem_secoes].sort((a, b) => a.posicao - b.posicao)
        : DEFAULT_ORDEM;

    // Garantir que `realestate` apareça mesmo em layoutConfig salvo antes da
    // adição da seção (registros antigos não têm essa chave em ordem_secoes).
    const ordemConfig = ordemBase.some(s => s.key === 'realestate')
        ? ordemBase
        : [...ordemBase, { key: 'realestate', label: 'Imóvel', posicao: ordemBase.length }];

    const secoesFiltradas = ordemConfig.filter(s => {
        if (s.key === 'campos_personalizados' && !hasCustomTabs) return false;
        if (s.key === 'realestate' && !hasRealEstate) return false;
        return sections[s.key] !== undefined && sections[s.key] !== null;
    });

    if (modo === 'tabs') {
        return (
            <TabsUI defaultValue={secoesFiltradas[0]?.key} className="w-full animate-in fade-in slide-in-from-left-4 duration-500 delay-300 fill-mode-both">
                <TabsListUI className="w-full flex gap-0.5 bg-gray-100/80 dark:bg-[#2a2d31] p-0.5 rounded-lg mb-3 overflow-x-auto">
                    {secoesFiltradas.map(secao => (
                        <TabsTriggerUI
                            key={secao.key}
                            value={secao.key}
                            className="flex-1 text-[11px] font-semibold uppercase tracking-wider px-1.5 py-1.5 whitespace-nowrap
                                text-gray-500 dark:text-neutral-400
                                data-[state=active]:bg-white data-[state=active]:dark:bg-[#383838]
                                data-[state=active]:text-neutral-800 data-[state=active]:dark:text-neutral-100
                                data-[state=active]:shadow-sm rounded-md transition-all"
                        >
                            {secao.label}
                        </TabsTriggerUI>
                    ))}
                </TabsListUI>
                {secoesFiltradas.map(secao => (
                    <TabsContentUI key={secao.key} value={secao.key} className="mt-0">
                        <div className="py-2">
                            {sections[secao.key]}
                        </div>
                    </TabsContentUI>
                ))}
            </TabsUI>
        );
    }

    // Accordion mode (default) — abrir todas as seções por padrão
    return (
        <Accordion type="multiple" defaultValue={secoesFiltradas.map(s => s.key)} className="w-full border border-gray-200 dark:border-[#383838] rounded-xl bg-neutral-50 dark:bg-[#222529] shadow-sm animate-in fade-in slide-in-from-left-4 duration-500 delay-300 fill-mode-both">
            {secoesFiltradas.map((secao, index) => (
                <AccordionItem
                    key={secao.key}
                    value={secao.key}
                    className={`px-2 ${index < secoesFiltradas.length - 1 ? 'border-b border-gray-200 dark:border-[#383838]' : 'border-none'}`}
                >
                    <AccordionTrigger className="hover:no-underline py-4 px-3 group">
                        <span className="text-[15px] font-bold text-neutral-800 dark:text-neutral-100 group-hover:text-[#0052cc] dark:group-hover:text-blue-400 transition-colors">
                            {secao.label}
                        </span>
                    </AccordionTrigger>
                    <AccordionContent className="px-3 pb-5">
                        {sections[secao.key]}
                    </AccordionContent>
                </AccordionItem>
            ))}
        </Accordion>
    );
}